import React, { Component } from 'react'
import { connect } from 'react-redux';
import { firestoreConnect, isLoaded, isEmpty } from 'react-redux-firebase'
import { compose } from 'redux'
import { getDateTimeString } from '../../../../helpers/dateHelper';
import { Link } from 'react-router-dom';

class SupplierRequests extends Component {
  render() {
    let { supplierRequests, areas } = this.props;


    if (!isLoaded(supplierRequests, areas) || isEmpty(supplierRequests))
      return <div />

    let requestComponents = supplierRequests.map((request) => {
      const areaName = areas.find((a) => a.id === request.areaId)?.name;
      return (
        <div key={request.reference.id} className="my-3 col-lg-6 col-md-12">
          <div className="card">
            <div className="card-body">
              <div><strong>Area:</strong> {areaName ?? "Non specificato"}</div>
              <div><strong>Data richiesta: </strong>{getDateTimeString(request.timestamp)}</div>
              <div><strong>Ragione sociale:</strong> {request.companyName}</div>
              <div><strong>Nome dell&apos;attività:</strong> {request.supplierName}</div>
              <div><strong>Nome titolare:</strong> {request.name}</div>
              <Link to={"/suppliers/requests/" + request.reference.id} className="btn btn-outline-primary mt-2">
                Visualizza richiesta
              </Link>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="my-4">
        <h4 className="my-auto">Richieste di collaborazione dai fornitori</h4>
        <div className="row">
          {requestComponents}
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    admin: state.firestore.data.currentAdmin,
    areas: state.firestore.ordered.areas,
    supplierRequests: state.firestore.ordered['supplierRequests'],
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    return [
      {
        collection: 'supplier_requests',
        orderBy: [['timestamp', 'desc']],
        where: [
          ['state', '==', "PENDING"],
          ...!props.admin.isMainAdmin ? [
            ["areaId", "in", props.admin.areaIds]
          ] : [],
        ],
        storeAs: 'supplierRequests',
      },
      {
        collection: "areas",
      }
    ];
  }),
)(SupplierRequests)